<template>
  <div class="body-wrapper">
    <img class="tick" src="@/assets/images/tickWhite.svg">

    <span class="success-title">
      Adım tamamlandı 🙌
    </span>

    <span class="success-description">
      {{ questionData?.name || 'No description available.' }}
    </span>
  </div>
</template>

<script>
export default{
  props:{
    questionData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  height: 100%;
  background-color: #1cad79;
}

.success-title {
  font-size: 20px;
  line-height: 20px;
  font-family: euclid_bold, sans-serif;
  color: #FFFFFF;
  margin-top: 10px;
}

.success-description {
  font-size: 14px;
  line-height: 14px;
  font-family: euclid_regular, sans-serif;
  max-width: 80%;
  text-align: center;
  color: #FFFFFF;
}

.tick {
  width: 96px;
  height: 96px;
}
</style>
